<template>
  <v-card class="insurances-faq" :level="1" heading="Dúvidas Frequentes">
    <ul>
      <li>
        <v-heading class="question" level="h6">Meu convênio não está nesta lista. Há algo que eu possa fazer?</v-heading>
        <div class="answer">
          <p>Confirme com sua operadora de saúde se a mesma realmente não é parceira do URC.</p>
          <p>Você pode entrar em contato conosco para conhecer nossas parcerias com descontos especiais na tabela particular</p>
        </div>
      </li>
      <li>
        <v-heading class="question" level="h6">Como sei em minha carteirinha que a URC atende meu convênio?</v-heading>
        <div class="answer">
          <p>Confirme com sua operadora de saúde se a mesma realmente não é parceira do URC.</p>
          <!-- <p>Em sua carteirinha do convênio deve constar o aviso <b>Atendimento Vale do Paraíba</b></p> -->
        </div>
      </li>
    </ul>
    <p class="hint">
      <b>Dica:</b> Verifique sempre com seu convênio quais serviços são credenciados para seu plano.
    </p>
  </v-card>
</template>

<script>
import Card from '@/components/layout/Card.vue';
import Heading from '@/components/uikit/text/Heading.vue';

export default {
  name: 'InsurancesFaq',
  components: {
    'v-card': Card,
    'v-heading': Heading,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.insurances-faq';
#{$component} {
  padding: 0;
  /deep/ .card__title {
    background-color: $color-e;
  }
  ul {
    padding: $gutter-l;
    li {
      margin-bottom: $gutter-xxl;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .answer {
      color: $color-sys-e;
      font-size: $font-size-l;
    }
  }
  .hint {
    padding: $gutter-l;
    margin: 0;
    border-top: 1px solid $color-sys-h;
    color: $color-sys-e;
    b {
      color: $color-sys-b;
    }
  }
}
</style>
